export const PATHS = {
  REGISTER: 'register',
};
